// NOTICE: KAPTION-INTEGRATION - app-studio.THEME.1
// The theme a dashboard app should use: the one the person sees. setColorTheme
// (themeHelper.js) resolves the appearance setting (light / dark / auto + the OS)
// into the `dark` class on <body>, so that class is the answer. ui_settings.theme
// is not: almost nobody has it, and the old `|| 'light'` sent light to every app.
export const kaptionDashboardAppTheme = () =>
  document.body?.classList.contains('dark') ? 'dark' : 'light';
